/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step2_TitleInputs */

const es_landing_step2_title = /** @type {(inputs: Landing_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A punto, a tu medida`)
};

const gl_landing_step2_title = /** @type {(inputs: Landing_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A punto, á túa medida`)
};

const en_landing_step2_title = /** @type {(inputs: Landing_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready, your way`)
};

/**
* | output |
* | --- |
* | "Ready, your way" |
*
* @param {Landing_Step2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step2_title = /** @type {((inputs?: Landing_Step2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step2_title(inputs)
	if (locale === "en") return en_landing_step2_title(inputs)
	return es_landing_step2_title(inputs)
});